import { render, staticRenderFns } from "./AddMultipleObjects.vue?vue&type=template&id=b5c84200&"
import script from "./AddMultipleObjects.vue?vue&type=script&lang=js&"
export * from "./AddMultipleObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports